// extracted by mini-css-extract-plugin
export var modal = "_ju-0";